<template>
    <div class="searchBox">
        <div class="inputBox">
            <i class="ico ico-icon_61"></i>
            <input type="text" v-model="goodsName" placeholder="请输入门店名称" />

            <i class="ico ico-icon_02 close" v-show="goodsName !==''" @click="onClearInput"></i>
        </div>
        <a href="javascript:void(0)" @click="onSearch">搜索</a>
    </div>
</template>

<script>

export default {
    name: 'countDownBox',
    props: {
        remainTime: {
            type: Number,
            default: 0
        }
    },
    components: {
    },
    data () {
        return {
            goodsName: '',
            state: 0, // 0 未开始 1 进行中 2 已结束
            nowTime: 0, // 当前时间
            timeInfo: {
                d: 0,
                h: 0,
                m: 0,
                s: 0
            }
        }
    },
    created () {

    },
    activated () {

    },
    watch: {
    },
    mounted () {
    },
    methods: {
        /**
         * 清空文本框
         */
        onClearInput () {
            this.goodsName = ''
        },
        /**
         * 搜索
         */
        onSearch () {
            this.$emit('onSearch', this.goodsName)
        },
        /**
         * 倒计时回调
         * @param {object} timeInfo
         */
        onCountDownCallBack (timeInfo) {
            this.timeInfo = timeInfo
            this.$emit('callBack', timeInfo)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables'
.searchBox
    // height 88px
    // width 100%
    padding 14px 0 14px 20px
    box-sizing border-box
    display flex
    justify-content center
    align-items center
    background #fff
    .inputBox
        flex 1
        position relative
        input
            padding 0 55px 0 60px
            color #333
            width 100%
            box-sizing border-box
            height 60px
            border-radius 30px
            display block
            background #efefef
        .ico-icon_61
            // overflow hidden
            position absolute
            top 10px
            left -1000px
            filter: drop-shadow(1014px 0 0 #999999);
            // background-blend-mode lighten
            // filter: drop-shadow(10px 0 0 #ccc);
            // background-image linear-gradient(#ccc, #ccc)
        .close
            position absolute
            right 10px
            top 8px
            transform scale(0.7)
            transform-origin: center center
    a
        display block
        color #3b3b3b
        font-size 28px
        padding 0 20px
</style>
